import { ISanitizedWorkDetails } from "@services/search/implementations/InventorySearchService/InventorySearchService"
import { TFilters } from "@typed/entities/Search"

export function archived(item: ISanitizedWorkDetails, filters: TFilters, archivedItemsIds: Set<string>): boolean {
	const { includeArchived, includeUnarchived } = filters.archived
	return (includeArchived && archivedItemsIds.has(item.id)) || (includeUnarchived && !archivedItemsIds.has(item.id))
}
